import primary from './primary';
import gray from './gray';
import red from './red';
import orange from './orange';
import emerald from './emerald';
import amber from './amber';
import cyan from './cyan';
import indigo from './indigo';
import purple from './purple';
import teal from './teal';
import green from './green';
import white from './white';
import pink from './pink';
import violet from './violet';
import lightblue from './light-blue';
import fuchsia from './fuchsia';
import rose from './rose';

const Palette = {
  ...green,
  ...primary,
  ...gray,
  ...red,
  ...orange,
  ...emerald,
  ...amber,
  ...cyan,
  ...indigo,
  ...purple,
  ...teal,
  ...white,
  ...fuchsia,
  ...lightblue,
  ...violet,
  ...pink,
  ...rose,
};

export default Palette;
